"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThumbnailListContainer = _styledComponents["default"].div.withConfig({
  componentId: "rmn6es-0"
})(["display:grid;grid-template-columns:33.3% 33.3% 33.3%;margin:-", "px;", "{display:flex;}"], (0, _themeGet.themeGet)('space.1'), (0, _themeGet.themeGet)('mediaQueries.lg'));

var ThumbnailContainer = (0, _styledComponents["default"])(_pclnDesignSystem.Link).withConfig({
  componentId: "rmn6es-1"
})(["padding:", "px;"], (0, _themeGet.themeGet)('space.1'));
var ImageGallery = (0, _react.memo)(function (_ref) {
  var images = _ref.images,
      thumbnailWidth = _ref.thumbnailWidth,
      thumbnailHeight = _ref.thumbnailHeight;
  return images && images.length > 0 ? _react["default"].createElement(ThumbnailListContainer, null, images.map(function (image, index) {
    return _react["default"].createElement(ThumbnailContainer, {
      key: index,
      href: image.src,
      target: "_blank"
    }, _react["default"].createElement(_pclnDesignSystem.Image, {
      src: image.thumbnail,
      alt: image.alt,
      width: thumbnailWidth,
      height: thumbnailHeight
    }));
  })) : null;
});
ImageGallery.displayName = 'ImageGallery';
ImageGallery.propTypes = {
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    thumbnail: _propTypes["default"].string,
    alt: _propTypes["default"].string
  })),
  thumbnailWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  thumbnailHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = ImageGallery;
exports["default"] = _default;